import React from "react";
import { Paper } from "@mui/material/index";
import styles from "./help.module.css";
import { ConnectCard } from "./Component/Help/ConnectCard";

import { IoCall } from "react-icons/io5";
import { AiFillMail } from "react-icons/ai";
import { RiWhatsappFill } from "react-icons/ri";

export const ConnectWithUs = () => {
  return (
    <>
      <div style={{ margin: "10px 0" }}>
        <Paper elevation={1} className={styles.papercontainer}>
          <div className={styles.heading}>Connect with us</div>
          <div style={{ margin: "20px 0px" }}>
            <ConnectCard
              title="Call Us"
              icon={<IoCall size="28" color="#7a51ae" />}
              contactdetails="(+91) 7428097301, Ext. - 7"
              btnText="Call Now"
              handleBtn={() => {
                window.open("tel:7428097301");
              }}
            />
            <ConnectCard
              title="Reach us on whatsapp at"
              icon={<RiWhatsappFill size="28" color="#7a51ae" />}
              contactdetails="(+91) 9810887895"
              btnText="Say Hi"
              handleBtn={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=9810887895&text=Hi"
                );
              }}
            />
            <ConnectCard
              title="Write Us"
              icon={<AiFillMail size="28" color="#7a51ae" />}
              contactdetails="contact@samvednacare.com"
              btnText="Email Us"
              handleBtn={() => {
                window.open("mailto:contact@samvednacare.com");
              }}
            />
          </div>
        </Paper>
      </div>
    </>
  );
};
